import React from "react";

const AuthInfo = React.createContext();

export default AuthInfo;
